<template>
  <div id="Services">
    <div class="maxContainer" v-if="servicesList && serviceProducts.length">
      <router-view />
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState, mapActions } from 'vuex'
export default {
  name: "ServicesBase",
  data() {
    return {};
  },
  computed: {
    ...mapState('services', ['servicesList', 'serviceProducts'])
  },
  methods: {
    ...mapActions('services', ['fetchAllProducts']),
    ...mapMutations('services', ['SET_SERVICE_PRODUCTS', 'SET_SERVICES_LIST']),
    getContent () {
      this.$prismic.client.getSingle('service-list').then((document) => {
        this.SET_SERVICES_LIST(document.data.servicetype)
      });

      this.$prismic.client.query(this.$prismic.Predicates.at('document.type', 'services'), { pageSize : 100 }).then((response) => {
        this.SET_SERVICE_PRODUCTS(response.results)
      });
    }
  },
  created () {
    this.fetchAllProducts()
    this.getContent()
  }
};
</script>

<style scoped>
.maxContainer {
  max-width: 1280px;
  margin: 0 auto;
}
@media (max-width: 767px) {
  #Services {
    margin-bottom: 70px;
  }  
}
</style>



// WEBPACK FOOTER //
// src/components/Services/ServicesBase.vue